module.exports = "/static/media/arrow.337b93a1.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/arrow.svg
// module id = 557
// module chunks = 0